export const LangEn = {
    name:'en',
    data:{
        'pageTitles': {
            'loginTempWorker': "Temp worker login — Jobbiz",
            'loginCompany': "Company login — Jobbiz",
            'registerTempWorker': "Temp worker sign-up — Jobbiz",
            'forgot': "Forgotten password — Jobbiz",
            'resetPassword': "Reset password — Jobbiz",
            'invitation': "Invitation — Jobbiz",
            'finalizeAccount': "Complete my account — Jobbiz",
            'finalizeRegistration': "Complete my sign-up — Jobbiz",
            'privatePoolJoin': "Join a talent pool — Jobbiz",
            'fallback': "Jobbiz - digital temp work agency"
        },
        'privatePool': {
            'loading': "Loading…",
            'of': {
                'elided': "of {company}",
                'plain': "of {company}"
            },
            'invalid': {
                'title': "This link is no longer valid",
                'text': "Ask the company that invited you for a new link."
            },
            'loadError': {
                'title': "Something went wrong",
                'text': "The page could not be loaded. Check your connection and try again.",
                'retry': "Try again"
            },
            'form': {
                'invites': "invites you to its talent pool",
                'title': "Join the talent pool {ofCompany}",
                'intro': "Leave your contact details: the company will be able to offer you its assignments. Jobbiz hires you as a temp worker and handles the contract and payroll.",
                'firstname': "First name",
                'lastname': "Last name",
                'phone': "Phone number",
                'email': "Email (optional)",
                'countryLabel': "Country code",
                'phoneInvalid': "Invalid number",
                'emailInvalid': "Invalid email address",
                'consent': "I agree to be contacted by {company} and Jobbiz about assignments.",
                'submit': "Join the talent pool",
                'poweredBy': "Powered by Jobbiz",
                'errors': {
                    'invalidInput': "Some details are invalid. Check them and try again.",
                    'tooManyRequests': "Too many attempts. Try again in a few minutes.",
                    'generic': "Something went wrong. Try again in a moment."
                }
            },
            'countries': {
                'MQ': "Martinique",
                'GP': "Guadeloupe",
                'FR': "France"
            },
            'confirmation': {
                'title': "You are in the talent pool",
                'text': "{company} will be able to invite you to its assignments. To receive them, finish signing up in the Jobbiz app: that is where you will sign your contracts.",
                'signUpWith': "Sign up with {phone}",
                'phoneHint': "This number is how the app will find you in the talent pool {ofCompany}.",
                'download': "Download the Jobbiz app",
                'appStore': "App Store",
                'googlePlay': "Google Play"
            }
        },
        "modalExp":{
            "name":"kd,mkdmdké"
        },
        "name":'Ceci est un test',
        map : new Map()
    }
}